import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=b2201eac&scoped=true&"
import script from "./searchForm.vue?vue&type=script&lang=js&"
export * from "./searchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2201eac",
  null
  
)

export default component.exports